import { api } from './api';

export interface CreateDirectPayReplayRequest {
  startQueryDate: string;
  endQueryDate: string;
  directPayMaterialVendorAlias?: string;
}

export interface CreateDirectPayReplayResponse {
  jobId: string;
  status: string;
}

export interface DirectPayReplayJobSummary {
  jobId: string;
  requestedByEmail: string | null;
  requestedAt: string | null;
  completedAt: string | null;
  status: string;
  startQueryDate: string;
  endQueryDate: string;
  directPayMaterialVendorAlias: string | null;
  initialFailed: number | null;
  duplicates: number | null;
  succeeded: number | null;
  remainingFailed: number | null;
}

export interface DirectPayReplayJobDetail extends DirectPayReplayJobSummary {
  logs: string[];
  error: string | null;
}

export const directPayReplayApi = api.injectEndpoints({
  endpoints: (build) => ({
    createDirectPayReplay: build.mutation<CreateDirectPayReplayResponse, CreateDirectPayReplayRequest>({
      query: (body) => ({ url: '/admin/direct-pay-replay', method: 'POST', body }),
    }),
    getDirectPayReplayJobs: build.query<{ jobs: DirectPayReplayJobSummary[] }, void>({
      query: () => ({ url: '/admin/direct-pay-replay', method: 'GET' }),
    }),
    getDirectPayReplayJob: build.query<{ job: DirectPayReplayJobDetail }, string>({
      query: (jobId) => ({ url: `/admin/direct-pay-replay/${jobId}`, method: 'GET' }),
    }),
  }),
});

export const { useCreateDirectPayReplayMutation, useGetDirectPayReplayJobsQuery, useGetDirectPayReplayJobQuery } =
  directPayReplayApi;
